import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Beaker, Award, Users } from 'lucide-react';
import TestimonialsBlock from '../components/TestimonialsBlock';

const AboutPage = () => (
  <div className="bg-black text-white">
    <section className="max-w-[1100px] mx-auto px-4 lg:px-8 py-20 text-center">
      <p className="text-[#909090] text-sm uppercase tracking-widest mb-3">About Hydro Health</p>
      <h1 className="text-4xl md:text-5xl font-bold mb-6">Quality without shortcuts.</h1>
      <p className="text-zinc-300 text-lg leading-relaxed">
        At Hydro Health, we work with our own brand &mdash; Hydro Formula. Driven
        by one belief: research-grade quality, designed for laboratories that
        require verified, reliable and transparently documented materials.
      </p>
    </section>

    <section className="max-w-[1400px] mx-auto px-4 lg:px-8 pb-20 grid md:grid-cols-3 gap-6">
      {[
        { icon: Beaker, title: 'Our Mission', text: 'Raise the standard of transparency and verification across the research peptide industry.' },
        { icon: Award, title: 'Our Standards', text: 'Every batch is independently lab-tested with an extended analytical panel — not just purity.' },
        { icon: Users, title: 'Our Customers', text: 'Researchers, laboratories and institutions worldwide trust us for reliable materials.' },
      ].map((b) => (
        <div key={b.title} className="bg-zinc-950 border border-zinc-900 hover:border-[#909090]/60 transition-colors rounded-md p-7">
          <b.icon className="text-[#909090] mb-4" size={32} />
          <h3 className="text-xl font-semibold mb-2">{b.title}</h3>
          <p className="text-zinc-400 leading-relaxed text-sm">{b.text}</p>
        </div>
      ))}
    </section>

    <TestimonialsBlock />

    <section className="border-y border-zinc-900 bg-gradient-to-b from-zinc-950 to-black py-20">
      <div className="max-w-[1100px] mx-auto px-4 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">Independent verification with Liquilabs</h2>
        <p className="text-zinc-300 text-lg leading-relaxed max-w-3xl mx-auto mb-8">
          Our Hydro Formula compounds are tested in collaboration with Liquilabs
          using a research verification protocol that surpasses standard industry testing.
        </p>
        <Link to="/coas" className="inline-flex items-center gap-2 bg-[#909090] hover:bg-[#a8a8a8] text-black font-semibold px-7 py-3.5 rounded transition-colors">
          View Lab COAs <ArrowRight size={18} />
        </Link>
      </div>
    </section>
  </div>
);

export default AboutPage;
